import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _find from 'lodash/find';
import _map from 'lodash/map';
import _unionBy from 'lodash/unionBy';
import {
  getThirdAnalyses,
  getThirdAnalysis,
  clearLocalThirdAnalyses,
  clearLocalActiveThirdAnalysis
} from './actions';

export const initialState = {
  all: { data: [], pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } },
  thirdAnalysis: { id: '', input: null, result: null, status: '', updated_at: '' },
  loading: { all: false, thirdAnalysis: false }
};

const slice = createSlice({
  name: 'thirdAnalyses',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getThirdAnalyses.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getThirdAnalyses.fulfilled, (state, action) => {
        const { third_analyses, pagination } = action.payload;
        const newData = _unionBy([...state.all.data, ...third_analyses], 'id');
        
        state.loading.all = false;
        state.all.data = newData;
        state.all.pagination = pagination;
      })
      .addCase(getThirdAnalyses.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getThirdAnalysis.pending, (state) => {
        state.loading.thirdAnalysis = true;
      })
      .addCase(getThirdAnalysis.fulfilled, (state, action) => {
        const { data: { third_analysis }, cable } = action.payload;
        const foundedThirdAnalysis = !!_find(state.all.data, (s) => s.id === third_analysis.id);
        const updatedThirdAnalysis = { ...state.thirdAnalysis, ...third_analysis };
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = foundedThirdAnalysis ? _map(state.all.data, (e) => e.id === third_analysis.id ? { ...e, ...third_analysis } : e) : [...[third_analysis], ...oldAllData]; 
        const pagination = foundedThirdAnalysis ? state.all.pagination : { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.thirdAnalysis = false;
        state.all.data = data; 
        state.all.pagination = pagination;
        if (foundedThirdAnalysis && !cable) state.thirdAnalysis = updatedThirdAnalysis;       
      })
      .addCase(getThirdAnalysis.rejected, (state) => {
        state.loading.thirdAnalysis = false;
      })
      .addCase(clearLocalThirdAnalyses, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveThirdAnalysis, state => {
        state.thirdAnalysis = initialState.thirdAnalysis;
      })
  }
})

export default slice.reducer;